'use client';
import {Store} from '@common/store/Store';
import {Div, isNotNullOrUndefinedOrEmpty, NotificationsComponent, useAddNotification} from '@eon.cz/apollo13-frontend-common';
import {Button} from '@mui/material';
import {redirect} from 'next/navigation';
import {FormattedMessage} from 'react-intl';
import {useSelector} from 'react-redux';

type Props = {
    environment: {
        SARA_CLIENT_ID: string | undefined;
        SARA_OAUTH_REDIRECT_URL: string | undefined;
        SARA_AUTHORIZATION_ENDPOINT: string | undefined;
        KUBERNETES_NAMESPACE: string | undefined;
    };
};
export const LoginPage = ({environment}: Props) => {
    const {notifications} = useSelector((state: Store) => state.notifications);

    const {closeNotification} = useAddNotification();

    const close = () => {
        closeNotification();
    };

    const handleLogin = () => {
        if (isNotNullOrUndefinedOrEmpty(environment.SARA_AUTHORIZATION_ENDPOINT)) {
            const uri = `${environment.SARA_AUTHORIZATION_ENDPOINT}?response_type=code&client_id=${environment.SARA_CLIENT_ID}&redirect_uri=${environment.SARA_OAUTH_REDIRECT_URL}&scope=openid`;
            redirect(uri);
        }
    };

    return (
        <>
            <NotificationsComponent
                notifications={notifications}
                onClose={close}
                isPreprodOrProd={environment.KUBERNETES_NAMESPACE === 'prod' || environment.KUBERNETES_NAMESPACE === 'preprod'}
            />
            <Div sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', width: 400, padding: 5}}>
                <Button
                    sx={{
                        maxWidth: 200,
                    }}
                    onClick={handleLogin}
                    fullWidth
                    variant="contained"
                    size="large"
                >
                    <FormattedMessage id="login" />
                </Button>
            </Div>
        </>
    );
};
